export default __webpack_public_path__ + "static/media/icon_tick_grey.e74be5c9.svg";